import React from 'react';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseSelectablePanelFeature from '@framework/workbench/common/feature/base-selectable-panel-feature';
import SelectablePanel from '@framework/workbench/common/components/selectable-panel';
import { ThemeColorCard } from '@framework/workbench/common/components/selectable-panel/theme-color-card';
import { CLASSIC_THEME } from '@src/slide/application/service/theme-color-manager/theme-config';
import i18n from '@i18next/i18n';
import { reaction } from 'mobx';
import { IThemeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

@Feature()
export class ChangeThemeColorFeature extends BaseSelectablePanelFeature {
    id = config.id;
    config = config;
    currentThemeModel?: IThemeModel;
    width = 280;
    colNumber = 4;
    constructor() {
        super();
        this.currentThemeModel = this.getAppService().editableServiceLayer?.themeColorManager.currentThemeModel;
        reaction(() => {
            const themeColorManager = this.getAppService().editableServiceLayer?.themeColorManager;
            return themeColorManager?.currentThemeModel;
        }, (currentThemeModel) => {
            this.currentThemeModel = currentThemeModel;
            this.toolbarService.$forceUpdate();
        });
        SlideDataServices.SDKDataServices.EventManager()
            ?.commandEvents.onUndoRedoChange(() => {
                const themeColorManager = this.getAppService().editableServiceLayer?.themeColorManager;
                this.currentThemeModel = themeColorManager?.currentThemeModel;
                this.toolbarService.$forceUpdate();
            });
    }

    public getContent() {
        return <SelectablePanel
            colNumber={this.colNumber}
            showArrow={false}
            style={{
                width: this.width,
            }}
            selectedId={this.currentThemeModel?.name}
            childrenElements={
                [
                    {
                        name: i18n.t('主题色'),
                        cardList:
                            CLASSIC_THEME.map(theme => ({
                                element: <ThemeColorCard
                                    themeColorManager={this.getAppService().editableServiceLayer?.themeColorManager}
                                    uiDataService={this.getUiDataService()}
                                    themeItem={theme} key={theme.id}
                                />,
                                id: theme.title || '',
                            })),
                    },
                ]
            } />;
    }
}
